// notifyPrefs.js — the "Notify me about" switches (Settings → Notifications),
// applied to the live in-app pop (toast, sound, desktop notification).
// Mirrors api/notify-message.js, which applies the same switches to phone
// push and the email fallback. A missing value counts as on.

export const NOTIFY_PREF_COLUMNS = 'notify_dms, notify_mentions, notify_janet'
export const NOTIFY_PREFS_EVENT = 'chatrone:notify-prefs'

// kind: the thread's kind ('dm' | 'space' | a record thread).
export function shouldPop({ kind, mentioned, fromJanet }, prefs = {}) {
  if (fromJanet && prefs.notify_janet === false) return false
  if (mentioned && prefs.notify_mentions !== false) return true
  if (kind === 'dm') return prefs.notify_dms !== false
  // Spaces have no switch of their own; record-thread chatter only pops on a mention.
  return kind === 'space'
}
